export default "https://legacy.eskolare-development.com/images/file-not-found.png";